<template>
  <div :class="isMobile?'mobile-footer':'footer'">
    <div class="content">
      <p>健康游戏忠告<br/>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
    </div>
    <div class="img">
      <img :src="staticUrl+'office/xzdzm/pc/zhuzi-logo.png'" class="zhuzi-logo">
    </div>
    <div class="link">
      <a v-for="(item,index) in footLinks" :key="index" :href="item.url" target="_blank">{{ item.name }}</a>
    </div>
    <div class="content">
      <p v-html="basicData.record_number"></p>
      <p>公司地址：{{ basicData.address }}</p>
      <p>{{ basicData.copyright }}</p>
      <p>{{ userAgent }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'newFooter',
  data () {
    return {
      userAgent: navigator.userAgent
    }
  },
  computed:{
    ...mapGetters(['isMobile','basicData','footLinks','staticUrl']),
  },
}
</script>

<style lang="scss">

</style>
